import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './styles.scss';
import { PrintConfig } from './../../components/common';

export default class Header extends Component {
    render() {
        return (
            <header className={styles.header}>
                <div className={`siteWidthContainer ${styles.container}`}>
                    <h1>
                        <NavLink to={`/`}>
                            <i className="icon-printer" />
                            Jammin'
                        </NavLink>
                    </h1>
                    <div><PrintConfig /></div>
                    <i className="icon-noon" />
                </div>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js